export const initialState = {
  profile: null,
  isMembership: 0,
  subscriptionDetails: null,
  coupon: null,
  IsShowDeleteAccountPopup: false,
  likedContent: [],
  likedPhotos: [],
  paidMindsets: {},
  promotionCode: {
    loading: false,
    data: {},
    errorMessage: null,
    visible: false,
  },
  stripeSetupIntent: {
    clientSecret: null,
    publicKey: null,
    errorMessage: null,
  },
};
